import axios from 'axios';
import _ from 'lodash';
import { createBaseTransferQuery } from './queries';

const addBaseTransfer = (model, localization) =>
    new Promise((resolve, reject) => {
        const query = createBaseTransferQuery({ model });
        const request = axios.post(query.url, { ...query.body });

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error(`Unable to add ${localization.general.transfer} transfer`));
            });
    });

export default addBaseTransfer;
